<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="addurl"
        >
          <div v-if="fields.length > 0">
            <div
              class="form-group row align-items-center"
              v-for="(input, k) in fields"
              :key="k"
            >
              <label for="inputs_qualification" class="col-sm-3 mb-0">
                {{ ++k + " " + $t("field_name") }}
              </label>
              <app-input
                id="inputs_qualification"
                class="col-sm-6"
                type="text"
                v-model="input.field"
                :required="true"
              />
              <span>
                <i
                  class="fas fa-minus-circle"
                  @click.prevent="remove(input.id)"
                >
                  Remove field</i
                >
              </span>
            </div>
          </div>
          <div v-else>
              <h3 class="text-center">No Field</h3>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import * as actions from "../../../../Config/ApiUrl";
import {
  axiosPost,
  axiosDelete,
  axiosGet,
} from "../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    category_id: Number,
  },
  data() {
    return {
      documentCategories: [],
      addurl: actions.DOCUMENT_EXTRA_FIELDS_STORE,
      preloader: false,
      modalId: "demo-view-fields-Modal",
      modalTitle: this.$t("view"),
      fields: [],
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
    }
  },
  methods: {
    remove(id) {
      axiosDelete(actions.DOCUMENT_FIELD_DELETE + "/" + id)
        .then((res) => {
          this.getDocumentFields();
          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          this.$toastr.e(error);
        })
        .finally(() => {});
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.inputs.document_name = response.data.name;
      this.uploade_files = response.data.files;
      this.preloader = false;
    },
    getDocumentFields() {
      axiosGet(actions.DOCUMENT_EXTRA_FIELDS_GET + "/" + this.category_id)
        .then((res) => {
          this.fields = res.data;
          
        })
        .catch((error) => {
          this.$toastr.e(error);
        })
        .finally(() => {});
    },
  },

  mounted() {
    $(function () {
    //   $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
      $("#removeclass .modal-footer ").css("display", "none");
    });
    this.getDocumentFields();
  },
};
</script>
